/**
 * Category Repository
 */

import { apiClient } from '../../client'
import type { PaginatedResponse } from '../role.repository'

export interface Category {
    id: number
    tenant_id: number

    en_name: string
    ar_name?: string | null
    status: number
    created_by?: number | null
    updated_by?: number | null
    created_at: Date
    updated_at: Date
    ref_code?: string

}

export interface CreateCategoryRequest {
    tenant_id: number

    en_name: string
    ar_name?: string
    status?: number
    ref_code?: string

}

export interface UpdateCategoryRequest {
    tenant_id?: number

    en_name?: string
    ar_name?: string
    status?: number
    ref_code?: string

}

class CategoryRepository {
    async getAll(page: number = 1, limit: number = 25, filters?: any): Promise<PaginatedResponse<Category>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        })

        if (filters) {
            if (filters.search) params.append('search', filters.search)
            if (filters.status) params.append('status', filters.status)
            if (filters.category_id) params.append('category_id', filters.category_id)
        }

        return apiClient.get<PaginatedResponse<Category>>(`/categories?${params.toString()}`)
    }

    async getById(id: number): Promise<Category> {
        return apiClient.get<Category>(`/categories/${id}`)
    }

    async create(data: CreateCategoryRequest): Promise<Category> {
        return apiClient.post<Category>('/categories', data)
    }

    async update(id: number, data: UpdateCategoryRequest): Promise<Category> {
        return apiClient.put<Category>(`/categories/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/categories/${id}`)
    }

    async exportToExcel(filters?: any): Promise<Blob> {
        const params = new URLSearchParams()
        if (filters?.search) params.append('search', filters.search)
        if (filters?.status) params.append('status', filters.status)

        if (filters?.category_id) params.append('category_id', filters.category_id.toString())

        const baseUrl = `/categories/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }
}

export const categoryRepository = new CategoryRepository()

